enum CompanyFilterType {
  Active = "ACTIVE",
  Declined = "DECLINED",
  ShowAll = "SHOW_ALL",
}

export default CompanyFilterType;
